import isEqual from 'lodash/isEqual.js';
import startCase from 'lodash/startCase.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoGroupCell from '../../components/table/cell-types/pendo-group-cell.vue.js';
import PendoGuideStatusCell from '../../components/table/cell-types/pendo-guide-status-cell.vue.js';

var script = {
  name: 'PendoGuidesTargetingEntity',
  components: {
    PendoTable,
    PendoGuideStatusCell,
    PendoGroupCell
  },
  props: {
    entityName: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: null
    },
    baseUrl: {
      type: String,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: [Number, String],
      default: null
    },
    guideItems: {
      type: Array,
      default: () => [],
      validator: guideItems => {
        try {
          if (!(guideItems instanceof Array)) {
            return false;
          }
          const requiredGuideKeys = ['name', 'id', 'state', 'group', 'segment'].sort();
          const requiredGroupKeys = ['name', 'color'].sort();
          const requiredSegmentKeys = ['name'].sort();
          for (let i = 0; i < guideItems.length; i++) {
            const guide = guideItems[i];
            if (!(guide instanceof Object)) {
              return false;
            }
            const guideKeys = Object.keys(guide).sort();
            const groupKeys = Object.keys(guide.group).sort();
            const segmentKeys = Object.keys(guide.segment).sort();
            if (!isEqual(guideKeys, requiredGuideKeys)) {
              console.error('Validation error in pendo-guides-targeting-entity on guide', guideKeys, requiredGuideKeys);
              return false;
            }
            if (!isEqual(groupKeys, requiredGroupKeys)) {
              console.error('Validation error in pendo-guides-targeting-entity on guide group', groupKeys, requiredGroupKeys);
              return false;
            }
            if (!isEqual(segmentKeys, requiredSegmentKeys)) {
              console.error('Validation error in pendo-guides-targeting-entity on guide segment', segmentKeys, requiredSegmentKeys);
              return false;
            }
          }
          return true;
        } catch (err) {
          console.error('Validation error from pendo-guides-targeting-entity for prop `guideItems`', err, guideItems);
          return false;
        }
      }
    }
  },
  data() {
    return {
      columns: [{
        prop: 'name',
        label: 'Guide Name',
        type: 'link',
        href: row => `${this.baseUrl}/${row.id}`,
        sortable: true,
        fixed: true
      }, {
        prop: 'group.name',
        label: 'Product Area',
        slot: 'group',
        sortable: true,
        visible: true
      }, {
        prop: 'segment.name',
        label: 'Segment',
        slot: 'segment',
        sortable: true,
        visible: true
      }, {
        prop: 'state',
        label: 'Guide Status',
        slot: 'state',
        sortable: true,
        visible: true,
        minWidth: 132,
        showOverflow: false
      }]
    };
  },
  computed: {
    title() {
      const formattedEntityName = startCase(this.entityName);
      return this.showTitle ? `Guides Targeting This ${formattedEntityName}` : '';
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guides-targeting-entity.vue2.js.map
